import TrainingContent from './TrainingContentView';

export default TrainingContent;
